export const hasPermission = (permissionName) => {
    const userPermissions = JSON.parse(localStorage.getItem('user_permissions') || '[]');
    const allPermissions = JSON.parse(localStorage.getItem('all_permissions') || '[]');
  
    const match = allPermissions.find(p => p.name === permissionName);
    if (!match) return false;
  
    return userPermissions.includes(match.id);
  };
  